<template>
  <div class="faq-detail">
    <nav-bar :title="$t('faqDetail.Faq详情')" :go-back="()=>{$router.go(-1)}"/>
    <div class="faq-container">
      <div class="detail-container">
        <div class="title">{{ detail.title }}</div>
        <div class="content" v-html="detail.content"></div>
        <div class="time">{{ detail.created_at | dateFormat }}</div>
      </div>
      <div class="zan-container">
        <van-divider>{{$t('faqDetail.是否有帮助')}}</van-divider>
        <div class="btn-group">
          <van-button @click="onUseful(true)" icon="good-job-o" :type="is_useful === 1?'primary':'default'" round>
          {{$t('faqDetail.有帮助')}}
          </van-button>
          <van-button @click="onUseful(false)" icon="good-job-o" :type="is_useful === -1?'primary':'default'" round>
          {{$t('faqDetail.没帮助')}}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {apiFaqDetail, apiFaqUseful} from '@/api/faq';
  import {mapGetters} from 'vuex';

  export default {
    name: 'faqDetail',
    mixins: [],
    props: {},
    model: {},
    components: {},
    data() {
      return {
        detail: '',
        is_useful: 0
      };
    },
    computed: {
      ...mapGetters(['vuexInitData'])
    },
    created() {
      this.getDetail();
    },
    methods: {
      onUseful(type) {
        if (type && this.is_useful === 1){
          return;
        }
        if (!type && this.is_useful === -1){
          return;
        }
        let params = {
          id: Number(this.$route.params.id),
          is_useful: type,
          sess_uuid: this.vuexInitData.sess_uuid
        };
        apiFaqUseful(params).then(res => {
          if (res.code === 0) {
            if (type) {
              this.is_useful = 1;
            } else {
              this.is_useful = -1;
            }
          }
        });
      },
      getDetail() {
        let params = {
          id: this.$route.params.id
        };
        apiFaqDetail(params).then(res => {
          if (res.code === 0) {
            this.detail = res.data;
          }
        });
      }
    }
  };
</script>

<style scoped lang="less">
.faq-detail {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.faq-container {
  flex: 1;
  overflow-x: hidden;
  overflow-y: scroll;
}
.detail-container {
  flex: 0 0 auto;
  background: #fff;
  padding: 16px 10px;

  .title {
    font-size: 16px;
    color: #242424;
    margin-bottom: 10px;
  }

  .content {
    color: #666;
    margin-bottom: 10px;
    /deep/ img {
      width: 100%;
    }
  }

  .time {
    text-align: right;
    font-size: 12px;
    color: #999;
  }
}

.zan-container {
  background: #fff;
  padding: 5px 20px;
  box-sizing: border-box;
  margin-top: 10px;

  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-bottom: 10px;

    .van-button__content {
      display: flex;
      align-items: center;
    }

    button:last-child {
      .van-icon {
        transform: rotate(180deg);
        transform-origin: center;
      }
    }
  }
}
</style>
